"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.FocusMenu = FocusMenu;
var _react = require("react");
/**
 * SPDX-FileCopyrightText: © 2025 Liferay, Inc. <https://liferay.com>
 * SPDX-License-Identifier: BSD-3-Clause
 */

function FocusMenu(_ref) {
  var children = _ref.children,
    condition = _ref.condition,
    onRender = _ref.onRender;
  (0, _react.useEffect)(function () {
    if (condition) {
      onRender();
    }
  }, [condition]);
  return children;
}